import {
    CHALLENGES_REQUESTED,
    CHALLENGES_SUCCEEDED,
    CHALLENGES_FAILED,
    TAGS_REQUESTED,
    TAGS_SUCCEEDED,
    TAGS_FAILED,
    USERS_REQUESTED,
    USERS_SUCCEEDED,
    USERS_FAILED,
    REPORT_PREVIEW_REQUESTED,
    REPORT_PREVIEW_SUCCEEDED,
    REPORT_PREVIEW_FAILED,
    REPORT_CSV_REQUESTED,
    REPORT_CSV_SUCCEEDED,
    REPORT_CSV_FAILED,
    COUNTRIES_AND_CITIES_REQUESTED,
    COUNTRIES_AND_CITIES_SUCCEEDED,
    COUNTRIES_AND_CITIES_FAILED,
    CLEAR_REPORT,
    SET_SELECTED_COUNTRIES,
    REPORT_MAP_DATA_REQUESTED,
    REPORT_MAP_DATA_SUCCEEDED,
    REPORT_MAP_DATA_FAILED,
} from './constants';

export function setMapDataLoading(params) {
    return {
        type: REPORT_MAP_DATA_REQUESTED,
        ...params,
    };
}

export function setMapDataSuccess({ mapData }) {
    return {
        type: REPORT_MAP_DATA_SUCCEEDED,
        mapData,
    };
}

export function setMapDataFailed(error) {
    return {
        type: REPORT_MAP_DATA_FAILED,
        error,
    };
}

export function setSelectedCountries(countries) {
    return {
        type: SET_SELECTED_COUNTRIES,
        countries,
    };
}
export function challengesRequested() {
    return {
        type: CHALLENGES_REQUESTED,
    };
}

export function challengesSucceeded(challenges) {
    return {
        type: CHALLENGES_SUCCEEDED,
        challenges,
    };
}

export function challengesFailed(error) {
    return {
        type: CHALLENGES_FAILED,
        error,
    };
}

export function countriesAndCitiesRequested() {
    return {
        type: COUNTRIES_AND_CITIES_REQUESTED,
    };
}

export function countriesAndCitiesSucceeded(countries) {
    return {
        type: COUNTRIES_AND_CITIES_SUCCEEDED,
        countries,
    };
}

export function countriesAndCitiesFailed(error) {
    return {
        type: COUNTRIES_AND_CITIES_FAILED,
        error,
    };
}

export function tagsRequested() {
    return {
        type: TAGS_REQUESTED,
    };
}

export function tagsSucceeded(tags) {
    return {
        type: TAGS_SUCCEEDED,
        tags,
    };
}

export function tagsFailed(error) {
    return {
        type: TAGS_FAILED,
        error,
    };
}

export function usersRequested() {
    return {
        type: USERS_REQUESTED,
    };
}

export function usersSucceeded(users) {
    return {
        type: USERS_SUCCEEDED,
        users,
    };
}

export function usersFailed(error) {
    return {
        type: USERS_FAILED,
        error,
    };
}

export function generatePreviewReportRequested(params) {
    return {
        type: REPORT_PREVIEW_REQUESTED,
        ...params,
        previewReportLoading: true,
        report: [], // clear previous data
        previewReport: [],
    };
}

export function generatePreviewReportSucceeded(res) {
    return {
        type: REPORT_PREVIEW_SUCCEEDED,
        ...res,
        previewReportLoading: false,
    };
}

export function generatePreviewReportFailed(error) {
    return {
        type: REPORT_PREVIEW_FAILED,
        error,
        previewReportLoading: false,
    };
}

export function generateCSVReportRequested(params) {
    return {
        type: REPORT_CSV_REQUESTED,
        ...params,
        csvReportLoading: true,
    };
}

export function generateCSVReportSucceeded(res) {
    return {
        type: REPORT_CSV_SUCCEEDED,
        ...res,
        csvReportLoading: false,
    };
}

export function generateCSVReportFailed(error) {
    return {
        type: REPORT_CSV_FAILED,
        error,
        csvReportLoading: false,
    };
}

export function clearReport() {
    return {
        type: CLEAR_REPORT,
        report: [],
        previewReport: [],
    };
}
